/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { SiTruenas } from "react-icons/si";
import Layout from "../../components/Layout/Layout";

const NewPrograms = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            easing: "ease-out",
            once: false,
        });
    }, []);
    return (
        <>
            <Layout>
                <section className="section section-masthead">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <div className="text-black" data-aos="zoom-in-left">
                                <div className="overflow ps-5">
                                    <h1 className="text_48_program" data-aos="zoom-out-up">
                                        Specific Programs
                                    </h1>
                                    <div className="text_24_program">
                                    Explore our wellness programs designed to improve quality of life through personalized data analysis and advanced technologies.
                                    </div>
                                    <div className="text_18_program">
                                        Discover our range of specific wellness programs tailored to various aspects of health and well-being. Each program integrates cutting-edge technologies and personalized data analysis to help you achieve your unique health goals.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <img src="/img/program1.jpg" className="w-100" alt="" data-aos="zoom-out-up" />
                        </div>
                    </div>
                </section>

                <div class="program-categories container my-4">
                    <h3 class="section-title">Our Program Categories</h3>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>Healthcare Integration</h4>
                            <p className="text_24_program">Programs that integrate with medical devices for real-time health monitoring and personalized recommendations.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>Fitness and Wellness</h4>
                            <p className="text_24_program">Customized fitness plans and wellness programs tailored to individual needs and goals.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>Corporate Wellness</h4>
                            <p className="text_24_program">Programs aimed at promoting health and productivity within corporate environments.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>Mental Health</h4>
                            <p className="text_24_program">Resources and support for managing stress and mental health, with personalized care.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>Sports and Athletics</h4>
                            <p className="text_24_program">Performance enhancement programs for athletes with real-time data insights.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>Nutrition</h4>
                            <p className="text_24_program">Personalized nutrition plans to support a balanced diet and healthy lifestyle.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>Education</h4>
                            <p className="text_24_program">Wellness resources for NGOs and communities, promoting health in underserved areas.</p>
                        </div>
                    </div>
                </div>

                <section className="section section-masthead">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <div className="text-black" data-aos="zoom-in-left">
                                <div className="overflow ps-5">
                                    <h1 className="text_48_program" data-aos="zoom-out-up">
                                        User Profiles
                                    </h1>
                                    <div className="text_24_program">
                                        Find programs tailored to different user needs, from general users to specific groups like athletes and seniors.
                                    </div>
                                    <div className="text_18_program">
                                        Our programs are designed to perfectly adapt to each user. We use an advanced approach that integrates biometric and genetic data analysis with information about health history, lifestyle, work environment, and more. With this continuous personalization, each program evolves according to the user’s progress, offering a truly unique and effective support experience.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <img src="/img/program2.webp" className="w-100" alt="" data-aos="zoom-out-up" />
                        </div>
                    </div>
                </section>

                <div class="program-categories container my-4">
                    <h3 class="section-title">Ultra-Personalized Programs by User Profile</h3>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>General Users</h4>
                            <p className="text_24_program">Adaptive programs for monitoring and improving daily health and well-being, evolving based on individual health data and preferences.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>Athletes</h4>
                            <p className="text_24_program">Custom performance programs for high-performance athletes, including real-time biometric data analysis, recovery measures, nutrition, and training goals.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>Seniors</h4>
                            <p className="text_24_program">Programs focused on maintaining health, mobility, and independence, with adjustments based on health history and real-time data.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>Children</h4>
                            <p className="text_24_program">Dynamic programs to promote growth and an active lifestyle, tailored to each child's specific health needs.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>Corporate Users</h4>
                            <p className="text_24_program">Wellness programs adapted to specific work conditions and employees' health goals.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>Military Personnel</h4>
                            <p className="text_24_program">Personalized programs addressing the unique health and performance needs of military personnel, adjusted for missions and work environments.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>Pre- and Post-Operative Individuals</h4>
                            <p className="text_24_program">Fully customized recovery programs based on specific health data before and after surgery, including medication monitoring and care recommendations.</p>
                        </div>
                    </div>
                </div>

                <section className="section section-masthead">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <div className="text-black" data-aos="zoom-in-left">
                                <div className="overflow ps-5">
                                    <h1 className="text_48_program" data-aos="zoom-out-up">
                                        Library Overview
                                    </h1>
                                    <div className="text_24_program">
                                        Discover our comprehensive library of content and services to meet various wellness and personal development needs, tailored for all ages and professions.
                                    </div>
                                    <div className="text_18_program">
                                        Immsy offers a broad range of content and services to support wellness and personal development for users of all ages, including seniors, children, military personnel, and frontline workers. Our library provides resources in multiple categories to help you achieve your goals.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <img src="/img/program3.jpg" className="w-100" alt="" data-aos="zoom-out-up" />
                        </div>
                    </div>
                </section>


                <div class="program-categories container my-4">
                    <h3 class="section-title">Explore Our Main Categories</h3>
                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>Personal Development</h4>
                            <p className="text_24_program">Personal Transformation, Personal Productivity, Leadership, Career Development, Parenting and Family Relationships, Happiness, Religion and Spirituality, Personal Branding, Creativity, Influence, Self-Esteem and Confidence, Stress Management, Memory and Learning Methods, Motivation</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>Health and Fitness</h4>
                            <p className="text_24_program">Fitness, General Health, Sports, Nutrition and Diet Plans, Yoga, Mental Health, Martial Arts and Self-Defense, Safety and First Aid, Dance, Meditation</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>Business and Career</h4>
                            <p className="text_24_program">Entrepreneurship, Communication, Management, Sales, Business Strategy</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>Community Support</h4>
                            <p className="text_24_program">Community Engagement, Events and Workshops, Wellness Challenges, Q&A Sessions</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>Exclusive Content</h4>
                            <p className="text_24_program">Wellness Videos, Articles and Podcasts, Monthly Webinars</p>
                        </div>
                    </div>
                </div>


                <section className="section section-masthead">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <div className="text-black" data-aos="zoom-in-left">
                                <div className="overflow ps-5">
                                    <h1 className="text_48_program" data-aos="zoom-out-up">
                                        Corporate Wellness Programs
                                    </h1>
                                    <div className="text_24_program">
                                        Wellness programs designed to promote health and productivity within corporate environments.
                                    </div>
                                    <div className="text_18_program">
                                        Our corporate wellness programs are specifically designed to improve employee health, enhance team cohesion, and boost overall productivity. Using advanced data analysis and innovative technologies, we provide tailored solutions that address the unique needs of each organization.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <img src="/img/program4.jpg" className="w-100" alt="" data-aos="zoom-out-up" />
                        </div>
                    </div>
                </section>

                <div class="program-categories container my-4">
                    <h3 class="section-title">Key Components of Our Wellness Programs</h3>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4> Employee Health Assessments</h4>
                            <p className="text_24_program">Offer comprehensive health assessments to identify risks and opportunities for improving employee health.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4> Workshops and Training</h4>
                            <p className="text_24_program">Conduct workshops on topics such as stress management, nutrition, and physical activity.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4> Health and Wellness Monitoring</h4>
                            <p className="text_24_program">Use real-time tracking tools to monitor employee health and wellness and adjust programs accordingly.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4> Fitness and Nutrition Programs</h4>
                            <p className="text_24_program">Provide exercise and nutrition plans tailored to employee needs and goals.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4> Mental Health Support</h4>
                            <p className="text_24_program">Offer resources and support for stress management and mental health in the workplace.</p>
                        </div>
                    </div>
                </div>

                <section className="section section-masthead">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <div className="text-black" data-aos="zoom-in-left">
                                <div className="overflow ps-5">
                                    <h1 className="text_48_program" data-aos="zoom-out-up">
                                        Fitness and Wellness Programs
                                    </h1>
                                    <div className="text_24_program">
                                        Personalized fitness plans and wellness programs tailored to individual goals and needs.
                                    </div>
                                    <div className="text_18_program">
                                        Our fitness and wellness programs are designed to help you achieve your unique health goals with personalized plans. Whether you want to improve your fitness, manage stress, or optimize your overall well-being, we offer tailored solutions that adapt to your needs and lifestyle. Our services will be available starting in the first quarter of 2025. Sign up now to join the waiting list and secure your spot.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <img src="/img/program5.jpg" className="w-100" alt="" data-aos="zoom-out-up" />
                        </div>
                    </div>
                </section>


                <div class="program-categories container my-4">
                    <h3 class="section-title">Key Features of Our Fitness and Wellness Programs</h3>
                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4> Personalized Fitness Plans</h4>
                            <p className="text_24_program">Custom exercise programs designed to match your fitness level, goals, and specific preferences.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4> Integration with Wearable Devices</h4>
                            <p className="text_24_program">Easily connect your wearable devices for real-time tracking and feedback.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4> Mindfulness and Stress Management</h4>
                            <p className="text_24_program">Incorporate mindfulness practices and stress management techniques into your wellness routine.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4> Nutrition Guidance</h4>
                            <p className="text_24_program">Receive personalized nutrition plans and guidance to complement your fitness goals.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4> Progress Tracking and Adjustments</h4>
                            <p className="text_24_program">Regularly monitor your progress and adjust your program as needed for optimal results.</p>
                        </div>
                    </div>
                </div>


                <section className="section section-masthead">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <div className="text-black" data-aos="zoom-in-left">
                                <div className="overflow ps-5">
                                    <h1 className="text_48_program" data-aos="zoom-out-up">
                                        Mental Health Programs
                                    </h1>
                                    <div className="text_24_program">
                                        Resources and support for managing stress and mental health through personalized care, 24/7 assistance, and professional guidance.
                                    </div>
                                    <div className="text_18_program">
                                        Our mental health programs provide personalized support whenever you need it. With our AI-driven services available 24/7, we detect specific needs and connect users with healthcare professionals if necessary. This approach ensures continuous protection of the individual and recommendations tailored to every situation. Our services will be available in the first quarter of 2025. Sign up now to join the waiting list and secure your spot.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <img src="/img/program6.jpg" className="w-100" alt="" data-aos="zoom-out-up" />
                        </div>
                    </div>
                </section>

                <div class="program-categories container my-4">
                    <h3 class="section-title">Key Components of Our Mental Health Programs</h3>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>Personalized Mental Health Assessments</h4>
                            <p className="text_24_program">Comprehensive evaluations to identify each individual's unique mental health needs.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>Access to Counselors and Therapists</h4>
                            <p className="text_24_program">Connect with mental health professionals for individual or group sessions when needed.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>24/7 AI Support</h4>
                            <p className="text_24_program">Our virtual counselor is available around the clock to provide immediate and personalized support.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>Automated Detection of Specific Needs</h4>
                            <p className="text_24_program">AI analyzes interactions in real time to detect emotional difficulties and recommend a healthcare professional if necessary.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>Stress Management Resources</h4>
                            <p className="text_24_program">Access tools and techniques for stress management, such as meditation, mindfulness, and breathing exercises.</p>
                        </div>
                    </div>
                </div>


                <section className="section section-masthead">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <div className="text-black" data-aos="zoom-in-left">
                                <div className="overflow ps-5">
                                    <h1 className="text_48_program" data-aos="zoom-out-up">
                                        Sports and Athletics Programs
                                    </h1>
                                    <div className="text_24_program">
                                        Programs designed to enhance athletic performance through comprehensive analysis, personalized training, and continuous progress tracking.
                                    </div>
                                    <div className="text_18_program">
                                        Our Sports and Athletics Programs are designed to help athletes achieve peak performance by utilizing advanced technologies and personalized data analysis. We provide a holistic approach that includes blood analysis, metabolism evaluation, psychological assessments, sleep monitoring, biometric data tracking, and recovery time optimization to create a program tailored to your unique needs. Join the waiting list to access these innovative services in the first quarter of 2025.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <img src="/img/program7.jpg" className="w-100" alt="" data-aos="zoom-out-up" />
                        </div>
                    </div>
                </section>


                <div class="program-categories container my-4">
                    <h3 class="section-title">Key Features of Our Sports and Athletics Programs</h3>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4> Blood and Biometric Analysis</h4>
                            <p className="text_24_program">Comprehensive blood tests and biometric data monitoring to optimize training, nutrition, and recovery strategies.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4> Metabolic and Psychological Assessments</h4>
                            <p className="text_24_program">Regular evaluations of your metabolism and mental state to ensure a balanced and effective training program.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4> Personalized Training Plans</h4>
                            <p className="text_24_program">Customized programs designed to align with your sport, fitness level, and performance objectives.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4> Sleep and Recovery Optimization</h4>
                            <p className="text_24_program">Analyze your sleep patterns and recovery times to tailor your training schedule and maximize performance.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4> Real-Time Data Insights</h4>
                            <p className="text_24_program">Leverage real-time data to monitor key performance metrics, including speed, endurance, and recovery.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4> Continuous Progress Tracking</h4>
                            <p className="text_24_program">Regular updates and feedback to help you adjust your training plan and achieve your goals.</p>
                        </div>
                    </div>
                </div>

                <section className="section section-masthead">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <div className="text-black" data-aos="zoom-in-left">
                                <div className="overflow ps-5">
                                    <h1 className="text_48_program" data-aos="zoom-out-up">
                                        Nutrition Programs
                                    </h1>
                                    <div className="text_24_program">
                                        Personalized nutrition plans and food tracking to support a balanced and healthy diet.
                                    </div>
                                    <div className="text_18_program">
                                        Our Nutrition Programs are designed to help you achieve your health goals through personalized nutrition plans and advanced food tracking tools. By tailoring dietary recommendations to your unique needs, we provide comprehensive support for maintaining a balanced and healthy diet. Join the waiting list to access these innovative services in the first quarter of 2025.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <img src="/img/program8.jpg" className="w-100" alt="" data-aos="zoom-out-up" />
                        </div>
                    </div>
                </section>

                <div class="program-categories container my-4">
                    <h3 class="section-title">Key Features of Our Nutrition Programs</h3>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4> Personalized Nutrition Plans</h4>
                            <p className="text_24_program">Customized dietary recommendations tailored to your health goals, preferences, and nutritional needs.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4> Advanced Food Tracking</h4>
                            <p className="text_24_program">Track your meals and monitor nutrient intake using our advanced food tracking tools.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4> Integration with Health Devices</h4>
                            <p className="text_24_program">Sync with your wearable devices to optimize your diet based on real-time health data.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4> AI-Driven Nutritional Insights</h4>
                            <p className="text_24_program">Receive AI-driven insights and suggestions to enhance your nutrition plan.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4> Continuous Progress Monitoring</h4>
                            <p className="text_24_program">Monitor your progress over time and adjust your nutrition plan as needed.</p>
                        </div>
                    </div>
                </div>


                <section className="section section-masthead">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <div className="text-black" data-aos="zoom-in-left">
                                <div className="overflow ps-5">
                                    <h1 className="text_48_program" data-aos="zoom-out-up">
                                        Education Programs
                                    </h1>
                                    <div className="text_24_program">
                                        Wellness resources and programs for NGOs and communities to promote health in underserved areas.
                                    </div>
                                    <div className="text_18_program">
                                        Our Education Programs provide essential wellness resources and support for NGOs and communities, focusing on promoting health in underserved areas. We offer tailored programs designed to empower local organizations and community leaders to improve the well-being of their populations through education, access to resources, and sustainable health practices. Join the waiting list to be among the first to access these services by the end of 2025.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <img src="/img/program9.jpg" className="w-100" alt="" data-aos="zoom-out-up" />
                        </div>
                    </div>
                </section>



                <div class="program-categories container my-4">
                    <h3 class="section-title">Key Features of Our Education Programs</h3>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>Customized Wellness Resources</h4>
                            <p className="text_24_program">Tailored educational materials and resources to support health promotion in local communities.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>Programs for NGOs and Community Leaders</h4>
                            <p className="text_24_program">Training and support programs for NGO workers and community leaders to implement wellness strategies effectively.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>Access to Online and Offline Resources</h4>
                            <p className="text_24_program">A comprehensive library of digital and physical wellness resources for ongoing community support.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>Health Workshops and Seminars</h4>
                            <p className="text_24_program">Organize local workshops and seminars to educate and engage communities on critical health issues.</p>
                        </div>
                    </div>

                    <div class="d-flex align-items-start mb-2">
                        <div class="icon me-2">
                            <SiTruenas />
                        </div>
                        <div class="category-content">
                            <h4>Sustainable Health Practices</h4>
                            <p className="text_24_program">Guidance on developing long-term, sustainable health practices tailored to community needs.</p>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    );
};

export default NewPrograms;
